'use strict'

import { apiInstance, legacyV2 } from './index'
import { mapArgs, sanitizeCostCenters } from 'utils/functions'

const project = {
  getProjectList (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/project-list`,
      params
    })
  },

  getProjects (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/project`,
      params
    })
  },

  getProjectById (projectId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/project/${projectId}`
    })
  },

  deleteProject (projectId) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2()}/project/${projectId}`
    })
  },

  addProject (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/project`,
      data
    })
  },

  updateProject (data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2()}/project/${data.id}`,
      data
    })
  },

  addOrEditProject (companyId, costCenters, name, projectId) {
    const costCentersSanitized = sanitizeCostCenters(costCenters)
    let method = 'post'
    let url = `${legacyV2()}/project`
    let params = {
      companyId,
      costCenters: costCentersSanitized,
      name
    }

    if (projectId) {
      method = 'put'
      url = `/project/${projectId}`
    }

    return apiInstance({
      method,
      url,
      data: params
    })
  },

  exportProjects (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/project/export`,
      timeout: 60000,
      responseType: 'blob',
      params
    })
  }
}

export default project
